import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// initializeApp throws synchronously on invalid config (e.g. missing apiKey).
// We swallow that here so the landing page still renders with email/password
// login; the Google button is hidden when isFirebaseConfigured is false.
export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey);

let _auth = null;
let _googleProvider = null;

if (isFirebaseConfigured) {
  try {
    const app = initializeApp(firebaseConfig);
    _auth = getAuth(app);
    _googleProvider = new GoogleAuthProvider();
  } catch (err) {
    console.warn("Firebase init failed; Google sign-in disabled.", err);
  }
} else {
  console.warn("REACT_APP_FIREBASE_API_KEY is not set; Google sign-in disabled.");
}

export const auth = _auth;
export const googleProvider = _googleProvider;
